
import { defineComponent } from "vue";

export default defineComponent({
  name: "element-ui",
  components: {}
});
